export default {"src":"/_next/static/media/tel.4c329f05.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};